<template>
  <span>
    <div class="attachment">
      <div class="icon"><i class="fal fa-file"></i></div>
      <div class="information">
        <div class="name" v-b-tooltip.hover :title="info.name">{{ info.name }}</div>
        <div class="filesize">
          <span v-if="info.size">{{bytesToSize(info.size)}} &nbsp;</span>
          <a download href="#" @click.prevent="download" class="clickable" v-show="!loading">
            <i class="fal fa-download"></i> {{$t("DOWNLOAD")
          }}</a>
        </div>
      </div>
    </div>
  </span>
</template>
<script>
import * as blobUtil from 'blob-util';
export default {
  props: ["item","index", "message_uuid", "user_uuid", "functionbox_uuid"],
  data() {
    return {
      loading: false,
      info: this.item,
      blob: null
    };
  },
  methods: {
    async download() {
      try {
        let result = await this.$http.post(
          this.user.hostname + "/download/generate",
          {
            functionbox_uuid: this.functionbox_uuid,
            user_uuid: this.user_uuid,
            message_uuid: this.message_uuid,
            attachment_index: this.index
          }
        );
        let openUrl = this.user.hostname + "/download/" + result.data.download_uuid;
        setTimeout(() => {
          window.open(openUrl);
        });
      } catch {
        let blob = blobUtil.base64StringToBlob(this.info.content, 'application/octet-stream');
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, this.info.name);
        } else {    
          let $link = document.createElement("a");
          let url = URL.createObjectURL(blob);
          $link.setAttribute("target", "_blank");
          $link.setAttribute("href", url);
          $link.setAttribute("download", this.info.name);
          $link.style.visibility = "hidden";
          document.body.appendChild($link);
          $link.click();
          document.body.removeChild($link);
        }
      }
    }
  }
};
</script>
<style>
</style>